import { Check, ArrowRight, ShieldCheck } from "lucide-react";

const FEATURES = [
  "Up to 60 photos",
  "Personalized music of your choice",
  "Cinematic motion & transitions",
  "Custom title cards (name & dates)",
  "HD digital delivery + USB option",
  "One round of revisions included",
];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <div className="overline mb-4">Pricing</div>
            <h2 className="serif text-4xl sm:text-5xl lg:text-[56px] font-light leading-[1.05] text-[#F5F0E8]">
              One flat rate.
              <span className="block italic text-[#E6B89C]">No surprises.</span>
            </h2>
            <p className="mt-5 text-[#A0988E] spectral leading-relaxed max-w-md">
              In a difficult week, the last thing you need is a complicated invoice.
              Everything is included — hand-finished with care.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 text-sm text-[#A0988E]">
              <ShieldCheck size={16} className="text-[#D4AF37]" />
              <span>100% remote — serving families worldwide every week.</span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative">
              {/* glow */}
              <div className="pointer-events-none absolute -inset-6 rounded-[28px] blur-2xl opacity-50"
                   style={{ background: "radial-gradient(600px 240px at 50% 0%, rgba(212,175,55,0.25), transparent 60%)" }} />
              <div className="relative card-surface p-8 sm:p-10 rounded-[22px]">
                <div className="flex items-start justify-between flex-wrap gap-4">
                  <div>
                    <div className="overline">Memorial Tribute Film</div>
                    <div className="mt-3 flex items-baseline gap-3">
                      <span className="serif text-6xl sm:text-7xl font-light text-[#F5F0E8] leading-none">$250</span>
                      <span className="text-[#A0988E] text-sm">flat rate</span>
                    </div>
                  </div>
                  <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[rgba(212,175,55,0.35)] text-[11px] tracking-widest uppercase text-[#D4AF37]">
                    Most families choose this
                  </span>
                </div>

                <div className="my-8 hair" />

                <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3.5">
                  {FEATURES.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-[15px] text-[#F5F0E8]/90">
                      <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full border border-[rgba(212,175,55,0.4)]">
                        <Check size={11} className="text-[#D4AF37]" strokeWidth={2.5} />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>

                <div className="mt-9 flex items-center gap-4 flex-wrap">
                  <a href="#contact" data-testid="pricing-cta" className="btn-primary">
                    Start Your Tribute
                    <ArrowRight size={16} />
                  </a>
                  <span className="text-sm text-[#A0988E]">Pay by Cash App after you upload photos — $257.50 incl. 3% Cash App fee.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
